<div *transloco="let t;" class="row flex gap-5 pt-26 h-full onboarding new-container"
  style="background-image: url('./assets/img/BG/BG-Onboarding.jpg');">
  <div class="col-lg-6 col w-full md:w-1/2 col">
    <div class="chat-container chat-container-column">
      <div class="chat-box flex-row first-block">
        <img src="./assets/img/Prof-light.png" class="prof" />
        <div class="chat-box-text">
          <h1 class="title-gradient gradient-pp ">{{t('onboarding.newCountryNewCurr')}}</h1>
          <p>{{t('onboarding.kryptCompanyDesc')}}</p>
        </div>
      </div>
      <div class="chat-box second-block">
        <div class="checkout-list" *ngIf="foundKryptomon!==undefined">
          <!--<h1 class="checkout-title title-gradient gradient-pp">Cart:</h1>-->
          <div class="checkout-item kryptomon">
            <img src="{{foundKryptomon.nft.image}}" />
            <div class="checkout-item-text">
              <h1>ID: {{foundKryptomon.nft.tokenId}}</h1>
              <p>{{t('shared.tier')}}: {{foundKryptomon.nft.stats.tier}}</p>
            </div>
            <div class="checkout-price" *ngIf="!loadingTxKryptomon && !successTxKryptomon">
              <p>${{foundKryptomon.order.priceUSD}}</p>
              <div class="divider"></div>
              <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{foundKryptomon.order.priceKMON}}</p>
            </div>
            <div class="checkout-price loading" *ngIf="loadingTxKryptomon && !successTxKryptomon">
              <fa-icon [icon]="['fas', 'spinner']" class="fa-spin"></fa-icon>
            </div>
            <div class="checkout-price loading" *ngIf="!loadingTxKryptomon && successTxKryptomon">
              <fa-icon [icon]="['fas', 'check']" class="checkmark-number"></fa-icon>
            </div>
          </div>
          <div class="checkout-item lootbox" *ngIf="selectedBox!==undefined">
            <img src="{{selectedBox.img}}" class="lb" />
            <div class="checkout-item-text">
              <h1>1 {{selectedBox.formattedName}}</h1>
            </div>
            <div class="checkout-price" *ngIf="!loadingTxLootbox && !successTxLootbox">
              <p>${{selectedBox.formattedPriceUSD}}</p>
              <div class="divider"></div>
              <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{selectedBox.formattedPriceKMON}}</p>
            </div>
            <div class="checkout-price loading" *ngIf="loadingTxLootbox && !successTxLootbox">
              <fa-icon [icon]="['fas', 'spinner']" class="fa-spin"></fa-icon>
            </div>
            <div class="checkout-price loading" *ngIf="!loadingTxLootbox && successTxLootbox">
              <fa-icon [icon]="['fas', 'check']" class="checkmark-number"></fa-icon>
            </div>
          </div>
          <div class="checkout-item unfreeze" *ngIf="unfreezeSelected">
            <img src="{{unfreezeSelected.img}}" class="uf" />
            <div class="checkout-item-text">
              <h1>1 {{unfreezeSelected.formattedName}}</h1>
            </div>
            <div class="checkout-price" *ngIf="!loadingTxUnfreeze && !successTxUnfreeze">
              <p>${{unfreezeSelected.formattedPriceUSD}}</p>
              <div class="divider"></div>
              <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{unfreezeSelected.formattedPriceKMON}}</p>
            </div>
            <div class="checkout-price loading" *ngIf="loadingTxUnfreeze && !successTxUnfreeze">
              <fa-icon [icon]="['fas', 'spinner']" class="fa-spin"></fa-icon>
            </div>
            <div class="checkout-price loading" *ngIf="!loadingTxUnfreeze && successTxUnfreeze">
              <fa-icon [icon]="['fas', 'check']" class="checkmark-number"></fa-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6 col w-full md:w-1/2 col card box-container" *ngIf="!loadingSwap && !loadingTxKryptomon && !loadingTxLootbox && !loadingTxUnfreeze && !successTxKryptomon && !successTxLootbox && !successTxUnfreeze && !successTxSwap">
    <!-- <div class="card box-container" 
      *ngIf="!loadingSwap && !loadingTxKryptomon && !loadingTxLootbox && !loadingTxUnfreeze && !successTxKryptomon && !successTxLootbox && !successTxUnfreeze && !successTxSwap">-->
      <div class="boxes-container">
        <p *ngIf="!isLonger">{{t('onboarding.lastStepGetMoreMsg')}}</p>
        <div class="boxes-list" *ngIf="parsedBoxes && !isLonger">
          <div class="boxes-item" *ngFor="let pb of purchaseBoxes; let i = index"
            [ngClass]="{'selected':boxSelected[i],'shrink': (boxSelected[0] || boxSelected[1] || boxSelected[2])}"
            (click)="selectBox(i)">
            <img src="{{pb.img}}" />
            <div class="box-detail">
              <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{pb.kmonAmountFormatted}}</p>
              <div class="divider"></div>
              <p class="kmon-bnb"><img src="./assets/img/Icon/Cur-BNB.png" />{{pb.bnbAmount}}</p>
            </div>
            <div class="price-item">
              <p class="usd-value">${{pb.totalValue}}</p>
            </div>
          </div>
        </div>
        <p class="total-value">{{t('shared.total')}}: ${{amountTotal}}</p>
        <p class="min-amount" *ngIf="amountTotal<25 && !hasFunds">{{t('onboarding.kmonMinAmountMsg')}}: $30</p>
        <div class="is-longer" *ngIf="isLonger">
          <h1>{{t('kmon.kogeaConnLatency')}}</h1>
          <p>{{t('kmon.bnbLatencyMsg')}}</p>
          <h1>{{t('kmon.simplexEmailMsg')}}</h1>
        </div>
      </div>
      <div class="buttons" *ngIf="parsedBoxes && !isLonger">

        <div class="button-outline" (click)="goBack()" *ngIf="!isLoading">{{t('shared.back')}}</div>
        <div class="button-gradient" (click)="startDirectPurchase()"
          *ngIf="!isLoading && hasFunds && !isRefill && hasFundsKMON">{{t('shared.buyWithKmon')}}</div>
        <div class="button-gradient" (click)="purchaseRouter()"
          *ngIf="!isLoading && hasFunds && !isRefill && hasFundsBNB">{{t('shared.buyWithBNB')}}</div>
        <div class="button-gradient" (click)="purchaseRouter()" *ngIf="!isLoading && (isRefill || !hasFunds)">
          {{t('shared.buyWithCreditCard')}}</div>
        <div class="button-outline" *ngIf="isLoading">
          <fa-icon [icon]="['fas', 'spinner']" class="fa-spin" *ngIf="isLoading"></fa-icon>
        </div>
      </div>
    <!-- </div> -->
    <div class="card loading-container"
      *ngIf="loadingTxKryptomon || loadingTxLootbox || loadingTxUnfreeze || loadingSwap">
      <div class="card-content loading-box">
        <h1 class="loading-dots">{{t('shared.processing')}}</h1>
        <!--<div class="loading">
          <fa-icon [icon]="['fas', 'spinner']" class="fa-spin"></fa-icon>
        </div>-->
      </div>
    </div>
    <div class="card loading-container"
      *ngIf="(!loadingTxKryptomon && !loadingTxLootbox && !loadingTxUnfreeze && !loadingSwap) && (successTxKryptomon || successTxLootbox || successTxUnfreeze || successTxSwap)">
      <div class="card-content loading-box">
        <div class="loading">
          <fa-icon [icon]="['fas', 'check']" class="checkmark-number"></fa-icon>
        </div>
        <h1>{{t('onboarding.everythingCompleted')}}</h1>
        <div class="buttons" *ngIf="parsedBoxes">
          <div class="button-gradient" (click)="goLastStep()">{{t('shared.next')}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="simplexWidget" [ngClass]="{'hide': !showWidget}" *ngIf="!waitingForFunds">
    <form id="simplex-form">
      <div id="checkout-element">
        <!-- checkout will be rendered here -->
      </div>
    </form>
    <div class="buttons">
      <div class="button-outline" (click)="closeSimplex()">Cancel</div>
    </div>
  </div>
  <div class="overlay" *ngIf="showOnramper" (click)="closeOnramper()">
    <iframe style="border-radius: 4px; border: 1px solid #58585f; margin: auto;max-width: 420px" [src]="srcOnramper"
      height="630px" width="420px" title="Onramper widget" allow="accelerometer; autoplay; camera; gyroscope; payment"
      class="iframe-onramper">
    </iframe>
    <!-- <div class="onramper-close-button">
      <div class="button-outline" (click)="showOnramper = false">Cancel</div>
    </div> -->
  </div>
</div>